export const getObjectKeyByValue = (object: object, valueToFind: string): string | undefined => {
  for (const [key, value] of Object.entries(object)) {
    if (value === valueToFind) {
      return key;
    }
  }
};

/**
 * Remove property from object.
 * @param objectKeys - property keys array.
 * @param object - given object.
 * @example objectWithoutA = removePropertyFromObject(['a'], { a:1, b:2, c:3 })
 */
export function removePropertyFromObject<T extends Record<string, unknown>>(
  objectKeys: string[],
  object: T
): Record<string, unknown> {
  const filtered: Record<string, unknown> = {};

  for (const key in object) {
    if (!objectKeys.includes(key)) {
      filtered[key] = object[key];
    }
  }

  return filtered;
}
